import yup from "src/validators/yup.Module";

export interface TributacaoCfopFiltrarDto {
  nome: string;
}

export interface TributacaoCfopDto {
  id: number;
  tributacaoId: number;
  cfop: string;
  tipoParametro: number;
  tipoParametroDescricao: string;
  parametroValor: string;
}

export const TributacaoCfopFiltrarSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
